module.exports = __webpack_public_path__ + "static/img/1425_phase_function_Paper_PointsHejduk_Prediction.20f08b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1425_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Kgb1
// module chunks = 0